import { StandardLayout } from "common/layouts/StandardLayout";
import React from "react";
import { Route } from "react-router-dom";
import { UserProfilePage } from "../UserProfilePage";

export const routes = (
  <Route path="/users/:userId" exact>
    {(props) => (
      <StandardLayout greyBg>
        <UserProfilePage userId={parseInt(props.match.params.userId, 10)} />
      </StandardLayout>
    )}
  </Route>
);
